"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Implementation of the external WorksheetContent namespace.
 * This does not follow the Impl pattern as WorksheetContent is
 * currently just a (single) property bag.
 */
var WorksheetContent = /** @class */ (function () {
    function WorksheetContent(_worksheet) {
        this._worksheet = _worksheet;
    }
    Object.defineProperty(WorksheetContent.prototype, "worksheet", {
        get: function () {
            return this._worksheet;
        },
        enumerable: true,
        configurable: true
    });
    return WorksheetContent;
}());
exports.WorksheetContent = WorksheetContent;
//# sourceMappingURL=WorksheetContent.js.map